import { render } from "./DirectMessagePage.vue.js?vue&type=template&id=67577ade!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DirectMessagePage.vue?vue&type=template&id=67577ade"
import script from "./DirectMessagePage.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DirectMessagePage.vue?vue&type=script&lang=js"
export * from "./DirectMessagePage.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DirectMessagePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/community/DirectMessagePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67577ade"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67577ade', __exports__)) {
    api.reload('67577ade', __exports__)
  }
  
  module.hot.accept("./DirectMessagePage.vue.js?vue&type=template&id=67577ade!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DirectMessagePage.vue?vue&type=template&id=67577ade", () => {
    api.rerender('67577ade', render)
  })

}


export default __exports__